import { render, staticRenderFns } from "./InformationSidebar.vue?vue&type=template&id=16007979&scoped=true"
import script from "./InformationSidebar.vue?vue&type=script&lang=js"
export * from "./InformationSidebar.vue?vue&type=script&lang=js"
import style0 from "./InformationSidebar.vue?vue&type=style&index=0&id=16007979&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16007979",
  null
  
)

export default component.exports